document.addEventListener('DOMContentLoaded', () => {
  const claimTableElement = $('#claim-table');
  if (!claimTableElement.length) return;

  const DEFAULT_CLAIM_TYPES = ['all'];
  const DEFAULT_STATUSES = ['current_payroll'];

  const employeeIdFromPath = () => {
    const pathParts = window.location.pathname.split('/');
    return pathParts[1] === 'employees' ? pathParts[2] : null;
  };

  const normalizedDate = (value) => {
    if (!value) return '';

    const date = moment(value, window.DATE_FORMAT, true);
    return date.isValid() ? date.format('YYYY-MM-DD') : value;
  };

  const filtersFromForm = () => ({
    claim_type: $('#claim-type').val() || [],
    statuses: $('#claim-statuses').val() || [],
    business_unit_id: $('#select-business-unit-filter').val() || '',
    employee_id: employeeIdFromPath(),
    from: normalizedDate($('#claims-from-filter').val()),
    to: normalizedDate($('#claims-to-filter').val()),
    search: $('#claims-search-filter').val().trim()
  });

  const comparableFilters = (filters) => ({
    ...filters,
    claim_type: [...filters.claim_type].sort(),
    statuses: [...filters.statuses].sort()
  });

  const filtersAreEqual = (left, right) => (
    JSON.stringify(comparableFilters(left)) === JSON.stringify(comparableFilters(right))
  );

  const validateDateRange = (filters) => {
    const from = filters.from ? moment(filters.from, 'YYYY-MM-DD', true) : null;
    const to = filters.to ? moment(filters.to, 'YYYY-MM-DD', true) : null;

    if ((filters.from && !from.isValid()) || (filters.to && !to.isValid())) {
      return 'Enter valid From and To dates.';
    }
    if (from && to && from.isAfter(to)) {
      return 'From date must be before or equal to To date.';
    }

    return null;
  };

  let appliedFilters = filtersFromForm();
  let pendingFilters = null;

  const updateDirtyState = () => {
    const filtersAreDirty = !filtersAreEqual(filtersFromForm(), appliedFilters);
    $('#claims-filter-dirty').toggleClass('d-none', !filtersAreDirty);
    $('#export-claims-csv-btn').prop('disabled', filtersAreDirty);
  };

  const claimTable = claimTableElement.DataTable({
    fixedHeader: true,
    processing: true,
    serverSide: true,
    searching: false,
    ajax: {
      type: 'GET',
      url: '/claims',
      dataType: 'json',
      data: (data) => {
        const currentOrder = data.order[0];
        const requestFilters = pendingFilters || appliedFilters;

        data.page = Math.floor(data.start / data.length) + 1;
        data.per_page = data.length;
        data.order = currentOrder.column.toString();
        data.direction = currentOrder.dir;
        data.claim_type = requestFilters.claim_type;
        data.statuses = requestFilters.statuses;
        data.business_unit_id = requestFilters.business_unit_id;
        data.employee_id = requestFilters.employee_id;
        data.from = requestFilters.from;
        data.to = requestFilters.to;
        data.search = requestFilters.search;
      },
      dataSrc: (response) => {
        if (pendingFilters) {
          appliedFilters = pendingFilters;
          pendingFilters = null;
          updateDirtyState();
        }

        return response.data;
      },
      error: () => {
        pendingFilters = null;
        updateDirtyState();
        append_errors_list_in_alert_container(['Unable to load claims. Please try again.']);
      }
    },
    columnDefs: [
      {
        bSortable: false,
        aTargets: [7]
      }
    ]
  });

  $(document).on(
    'change input dp.change',
    '#claim-type, #claim-statuses, #select-business-unit-filter, #claims-from-filter, ' +
      '#claims-to-filter, #claims-search-filter',
    updateDirtyState
  );

  const bindExclusiveAllOption = (selector) => {
    $(selector).on('select2:select', (event) => {
      const selectedOption = event.params.data.id;
      const selectedValues = $(selector).val() || [];

      if (selectedOption === 'all') {
        $(selector).val(['all']).trigger('change');
      } else if (selectedValues.includes('all')) {
        $(selector).val(selectedValues.filter((value) => value !== 'all')).trigger('change');
      }
    });
  };

  bindExclusiveAllOption('#claim-type');
  bindExclusiveAllOption('#claim-statuses');

  $('#claims-apply-filters').on('click', () => {
    const draftFilters = filtersFromForm();
    if (!draftFilters.statuses.length) {
      append_errors_list_in_alert_container(['Select at least one processing status.']);
      return;
    }

    const dateError = validateDateRange(draftFilters);
    if (dateError) {
      append_errors_list_in_alert_container([dateError]);
      return;
    }

    pendingFilters = draftFilters;
    updateDirtyState();
    claimTable.page('first').draw('page');
  });

  $('#claims-reset-filters').on('click', () => {
    $('#claim-type').val(DEFAULT_CLAIM_TYPES).trigger('change');
    $('#claim-statuses').val(DEFAULT_STATUSES).trigger('change');
    $('#select-business-unit-filter').val('').trigger('change');
    $('#claims-from-filter, #claims-to-filter, #claims-search-filter').val('');
    $('#claims-apply-filters').trigger('click');
  });

  $('#claims-clear-dates').on('click', () => {
    $('#claims-from-filter, #claims-to-filter').val('');
    updateDirtyState();
  });

  $('#claims-search-filter').on('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      $('#claims-apply-filters').trigger('click');
    }
  });

  $('#export-claims-csv-btn').on('click', (event) => {
    event.preventDefault();

    $.ajax({
      type: 'POST',
      url: $(event.currentTarget).data('url'),
      dataType: 'json',
      headers: { 'X-CSRF-Token': $('meta[name=csrf-token]').attr('content') },
      data: appliedFilters,
      success: (response) => {
        append_success_message_in_alert_container(response.message);
        $('html').scrollTop(0);
      },
      error: (xhr) => {
        const message = xhr.responseJSON?.message || 'Unable to generate claims CSV.';
        append_errors_list_in_alert_container([message]);
        $('html').scrollTop(0);
      }
    });
  });
});
